import React, { useEffect, useRef } from 'react';
import Toast from '../component/toast/Toast';

export const MessageContext = React.createContext({});

export const MessageProvider = props => {
    const messageRef = useRef();

    const showSuccessMessage = (message, position = 'bottom-right') => {
        if (messageRef.current) {
            messageRef.current.success(message, position);
        }
    };

    const showErrorMessage = (message, position = 'bottom-right') => {
        if (messageRef.current) {
            messageRef.current.error(message, position);
        }
    };

    const showWarningMessage = (message, position = 'bottom-right') => {
        if (messageRef.current) {
            messageRef.current.warning(message, position);
        }
    };

    useEffect(() => {
        const handler = event => {
            const payload = event.detail;

            if (!payload) return;

            messageRef.current?.error({
                title: payload.title ?? 'Server error',
                detail: payload.detail ?? 'Internal server error',
                trace_id: payload.trace_id,
                status: payload.status,
                instance: payload.instance,
            });
        };

        window.addEventListener('vend:http-error', handler);

        return () => {
            window.removeEventListener('vend:http-error', handler);
        };
    }, []);

    const value = {
        showSuccessMessage,
        showErrorMessage,
        showWarningMessage,
    };

    return (
        <React.Fragment>
            <MessageContext.Provider value={value}>
                <Toast ref={messageRef} />
                {props.children}
            </MessageContext.Provider>
        </React.Fragment>
    );
};